declare global {
  interface Navigator {
    connection?: {
      saveData?: boolean;
      downlink?: number; // mbps
      effectiveType?: 'slow-2g' | '2g' | '3g' | '4g';
    };
  }
}

const resolveNetworkInformation = () => {
  const { connection } = window.navigator;

  if (!connection) {
    return false;
  }

  return (
    connection.saveData ||
    [undefined, 'slow-2g', '2g', '3g'].includes(connection.effectiveType)
  );
};

export const useNetworkInformation = () => {
  return {
    shouldSaveData: resolveNetworkInformation(),
  };
};
